// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator payroll_bundle`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'
import companies from 'modules/core/store/collections/companies'
import features from 'modules/core/store/collections/features'
import legalEntities from 'modules/core/store/collections/legalEntities'
import users from 'modules/core/store/collections/users'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import contractVersionsPayrollPolicies from 'modules/contracts/store/collections/contractVersionsPayrollPolicies'
import employeeGroups from 'modules/employees/store/collections/employeeGroups'
import employees from 'modules/employees/store/collections/employees'
import payrollPolicies from 'modules/payroll_bundle/store/collections/policies'
import policyPeriods from 'modules/payroll_bundle/store/collections/policyPeriods'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  /* contractVersionsPayrollPolicies manually fetched by 1 pages in this module */
  /* features manually fetched by 1 pages in this module */
  const collections: CollectionBootstrapConfig[] = [
    [companies, {}] /* Referenced by 62 cases in this module */,
    [contractVersions, {}] /* Referenced by 2 cases in this module */,
    [contractVersionsPayrollPolicies, {}] /* Referenced by 2 cases in this module */,
    [employeeGroups, {}] /* Referenced by 31 cases in this module */,
    [employees, {}] /* Referenced by 242 cases in this module */,
    [features, {}] /* Referenced by 125 cases in this module */,
    [legalEntities, {}] /* Referenced by 247 cases in this module */,
    [memberships, {}] /* Referenced by 2 cases in this module */,
    [payrollPolicies, {}] /* Referenced by 34 cases in this module */,
    [policyPeriods, {}] /* Referenced by 2 cases in this module */,
    [teams, {}] /* Referenced by 2 cases in this module */,
    [users, {}] /* Referenced by 140 cases in this module */,
  ] /* Generated file 👉 artifacts/payroll_bundle-module-index.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
